import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "20",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M11.809 17.408c3.486-.231 6.262-3.047 6.49-6.583a16 16 0 0 0 0-2.1c-.228-3.535-3.004-6.351-6.49-6.583a28 28 0 0 0-3.618 0C4.705 2.374 1.929 5.19 1.7 8.725a17 17 0 0 0 0 2.1c.083 1.288.653 2.48 1.323 3.487.39.705.132 1.584-.273 2.353-.292.553-.438.83-.321 1.03s.38.207.904.22c1.037.025 1.736-.269 2.29-.678.316-.232.473-.348.581-.362.109-.013.322.075.75.25.383.159.828.256 1.237.283a28 28 0 0 0 3.618 0Z"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-width": "1.5",
      d: "M8.75 7.948c0-.708.56-1.282 1.25-1.282s1.25.574 1.25 1.282a1.3 1.3 0 0 1-.198.693C10.678 9.236 10 9.804 10 10.512v.32"
    }, null, -1),
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M10 12.5h.008"
    }, null, -1)
  ]))]))
}
export default { render: render }